import React, { useState } from 'react'

import QRimage from '../../media/qrcode.png'
import wpIcon from '../../media/whatsapp.png'
import mpIcon from '../../media/icons/mercadopago.jpg'
import moneyIcon from '../../media/icons/monyIcon.png'

import toteImg from '../../media/subli/1.png'
import capImg from '../../media/subli/3.png'
import mugImg from '../../media/subli/4.png'
import tshirtImg from '../../media/subli/2.png'


//TODO agregar verdaderos valores whatsapp, precios y mp
//TODO agregar items de sublimacion
//TODO seccionar en componentes puros
//TODO agregar icono fotocopiadora
//TODO dividir en en varias paginas


function Discounts() {

  const [calculatorValues, setCalculatorValues] = useState({
    copiaColorSimple:"",
    copiaColorDoble:"",
    copiaNegroSimple:"",
    copiaNegroDoble:""
  })


  return (
    <div className="d-flex flex-column flex-wrap creamBackground">

      <div>
                <div className="container-fluid my-3 text-center">
                        <div className="militaryBackground rounded-4">
                            <div className="container-fluid py-5 ">
                                <h1 className="display-5 fw-bold tittle text-white">Fotocopiadora</h1>
                                <h2 className="display-5 fw-bold tittle regularText text-white">FORESTALES</h2>
                            </div>
                        </div>
                </div>
        
                <div className="militaryBackground p-3">
                    <div className=" d-flex flex-row flex-wrap gap-2 text-center justify-content-center align-items-center">
                        <span className="fw-bold text-white regularText">COPIAS</span>
                        <span className="fw-bold text-white regularText">IMPRESIONES</span>
                        <span className="fw-bold text-white regularText">STICKERS</span>
                        <span className="fw-bold text-white regularText">ANILLADOS</span>
                        <span className="fw-bold text-white regularText">SUBLIMACIONES</span>
                        <span className="fw-bold text-white regularText">FOTOS</span>
                    </div>     
                </div>
      </div>



      <div className="bg-white py-4">

          <div className='text-center d-flex flex-column justify-content-center align-items-center mt-4'>
              <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5">Envía tu archivo al </h2>
              <p className="dark fs-2">   385-313-6610   </p>
              <img className="col-md-5 col-8 pb-5" src={QRimage} alt="QRcode example" />
              
              <div className=" clickOver mt-3 px-3 d-flex flex-row creamBackground align-items-center justify-content-center">
                
                <a href="https://wa.me/543853136610" target="_blank">
                  <p className=" col-10 regularText dark rounded-5 py-3 px-5">O haz click aquí para iniciar una conversación por WhatsApp</p>
                </a>
                <a href="https://wa.me/543853136610" target="_blank">
                  <img width="36px"  src={wpIcon} alt="whatsAppIcon" />
                </a>

              </div>
          </div>


          <div className="text-center d-flex flex-column justify-content-center align-items-center mt-5">
              <h2 className="mainText fw-bold tittle dark mt-4">PRECIOS</h2>
              <div className=" d-flex flex-row col-11 mt-4">
                  <div className="col-6 d-flex flex-column gap-2">
                    <h2 className="regularText creamBackground rounded-4 fw-bold dark py-2 mx-1 mb-4">NEGRO</h2>
                      <span className="fs-2 regularText militaryBackground rounded-4 fw-bold text-white py-2 mx-1">40.00 $</span>
                      <label>Simple</label>
                      <span className="fs-2 regularText militaryBackground rounded-4 fw-bold text-white py-2 mx-1">25.00 $</span>
                      <label>Doble (por cara)</label> 
                  </div>
                  <div className="col-6 d-flex flex-column gap-2">
                      <h2 className="regularText creamBackground rounded-4 fw-bold dark py-2 mx-1 mb-4">COLOR</h2>
                      <span className="fs-2 regularText militaryBackground rounded-4 fw-bold text-white py-2 mx-1">70.00 $</span>
                      <label>Simple</label>
                      <span className="fs-2 regularText militaryBackground rounded-4 fw-bold text-white py-2 mx-1">60.00 $</span>
                      <label>Doble (por cara)</label>
                  </div>
              </div>
          </div>


          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
            <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5 mt-5">Calculadora</h2>
            <p className="px-2 text-center dark my-4">Introduce el número de páginas a imprimir y calcula el precio aproximado de tu impresión</p>

            <label className='dark regularText mt-3'>COPIAS A COLOR</label>
            <div className="my-4 creamBackground rounded-4 p-4">
                <div>
                  <label htmlFor="calculatorInputColorSimple">Copias simples</label>
                  <input id='calculatorInputColorSimple' value={calculatorValues.copiaColorSimple} onChange={e => setCalculatorValues({...calculatorValues,copiaColorSimple:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>

                <div>
                  <label htmlFor="calculatorInputColorDoble">Copias a dobles</label>
                  <input id='calculatorInputColorDoble' value={calculatorValues.copiaColorDoble} onChange={e => setCalculatorValues({...calculatorValues, copiaColorDoble:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>
            </div>

            <label className='dark regularText mt-3'>COPIAS BLANCO-NEGRO</label>
            <div className="my-4 creamBackground rounded-4 p-4">
                <div>
                  <label htmlFor="calculatorInputNegroSimple">Copias simples</label>
                  <input id='calculatorInputNegroSimple' value={calculatorValues.copiaNegroSimple} onChange={e => setCalculatorValues({...calculatorValues,copiaNegroSimple:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>

                <div>
                  <label htmlFor="calculatorInputNegroDoble">Copias a dobles</label>
                  <input id='calculatorInputNegroDoble' value={calculatorValues.copiaNegroDoble} onChange={e => setCalculatorValues({...calculatorValues,copiaNegroDoble:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>
            </div>

            <label className='dark regularText mt-3'>Anillados</label>
            <div className="my-4 creamBackground rounded-4 p-4">
                <div>
                  <label htmlFor="calculatorInputNegroSimple">Copias simples</label>
                  <input id='calculatorInputNegroSimple' value={calculatorValues.copiaNegroSimple} onChange={e => setCalculatorValues({...calculatorValues,copiaNegroSimple:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>

                <div>
                  <label htmlFor="calculatorInputNegroDoble">Copias a dobles</label>
                  <input id='calculatorInputNegroDoble' value={calculatorValues.copiaNegroDoble} onChange={e => setCalculatorValues({...calculatorValues,copiaNegroDoble:e.target.value})} class="form-control form-control-lg" type="text" placeholder="0 copias" aria-label=".form-control-lg example"/>
                </div>
            </div>


            <h2>TOTAL</h2>
            <p>{(calculatorValues.copiaColorDoble*60 )+(calculatorValues.copiaColorSimple*70)+(calculatorValues.copiaNegroDoble*25)+(calculatorValues.copiaNegroSimple*40) +"$" }</p>
          </div> 



          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
            <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5">ART. SUBLIMACIÓN</h2>
            <div className="d-flex flex-row flex-wrap justify-content-center align-items-center gap-3 mt-5">

              <div className="card border-0 col-5 creamBackground" >
                <img src={toteImg} className="card-img-top" alt="tote"/>
                <div className="card-body text-center">
                  <h2>$400</h2>
                  <p className="card-text">TOTE O BOLSA</p>
                </div>
              </div>

              <div className="card border-0 col-5 creamBackground" >
                <img src={capImg} className="card-img-top" alt="gorra"/>
                <div className="card-body text-center">
                  <h2>$1200</h2>
                  <p className="card-text">GORRA TRUCK</p>
                </div>
              </div>

              <div className="card border-0 col-5 creamBackground" >
                <img src={mugImg} className="card-img-top" alt="taza"/>
                <div className="card-body text-center">
                  <h2>$1300</h2>
                  <p className="card-text">TAZA CERÁMICA</p>
                </div>
              </div>

              <div className="card border-0 col-5 creamBackground" >
                <img src={tshirtImg} className="card-img-top" alt="remera"/>
                <div className="card-body text-center">
                  <h2>$2000</h2>
                  <p className="card-text">REMERA</p>
                </div>
              </div>

            </div>
          </div>

          <div className="d-flex flex-column justify-content-center align-items-center text-center mt-5">
            <h2 className="mainText fw-bold tittle dark mt-4">PAGOS</h2>
            <div className="d-flex flex-row col-12 mt-5 px-4">
                <span className="clickOver greenborder col-6 p-2  d-flex flex-column justify-content-center align-items-center rounded-4">
                  <img width="90px" src={mpIcon} alt="mpIcon" />
                </span>
                <span className="clickOver greenborder col-6 p-2 d-flex flex-column justify-content-center align-items-center rounded-4">
                  <img   src={moneyIcon} alt="moneyIcon" />
                  <p className="regularText dark fw-bold">Efectivo</p>
                </span>
            </div>
            
            <p className="regularText creamBackground rounded-4 fw-bold dark py-2 px-4 mx-1 my-4">ALIAS:</p>
            <p className="fs-2 regularText militaryBackground rounded-4 fw-bold text-white py-2 mx-1 px-3">fotocopiadora.forestales</p>

          </div>   
      </div>     

    </div>
  )
}

export default Discounts